import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Mail, CheckCircle2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import { API } from '../context/AuthContext';
import { AuthCard, Field, ErrorBox, formatApiError } from '../components/auth/AuthCard';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(''); setBusy(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email: email.trim() });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  return (
    <AuthCard title="ପାସୱାର୍ଡ ଭୁଲିଗଲେ?" subtitle="ଆପଣଙ୍କ ଇମେଲ୍ ଦିଅନ୍ତୁ — ଆମେ ଏକ reset ଲିଙ୍କ୍ ପଠାଇବୁ" back="/login">
      {sent ? (
        <div className="text-center py-3" data-testid="forgot-success">
          <CheckCircle2 size={44} className="mx-auto text-emerald-600" />
          <div className="font-bold text-gray-900 mt-3">ଇମେଲ୍ ଯାଞ୍ଚ କରନ୍ତୁ</div>
          <p className="text-sm text-gray-600 mt-1">ଯଦି <b>{email}</b> ପଞ୍ଜୀକୃତ ଅଛି, ଏକ reset ଲିଙ୍କ୍ ପଠାଯାଇଛି। ଲିଙ୍କ୍ ୬୦ ମିନିଟ୍ ପାଇଁ ବୈଧ। Spam ଫୋଲ୍ଡର ମଧ୍ୟ ଦେଖନ୍ତୁ।</p>
          <Link to="/login" className="inline-block mt-4 text-sm font-bold text-emerald-700" data-testid="forgot-back-to-login">ଲଗଇନ୍ ପୃଷ୍ଠାକୁ ଫେରନ୍ତୁ</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-3" data-testid="forgot-form">
          <Field label="ଇମେଲ୍ / Email" type="email" required autoComplete="email" testId="forgot-email-input"
            value={email} onChange={e => setEmail(e.target.value)} placeholder="you@example.com" />
          <ErrorBox message={error} testId="forgot-error" />
          <Button type="submit" disabled={busy} data-testid="forgot-submit-button"
            className="w-full h-12 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white font-bold gap-2">
            <Mail size={16} /> {busy ? 'ପଠାଉଛି…' : 'Reset ଲିଙ୍କ୍ ପଠାନ୍ତୁ'}
          </Button>
        </form>
      )}
    </AuthCard>
  );
}
